module.exports = __webpack_public_path__ + "img/creditCard.59773dce.svg";